<div class="toka-info">
    <div class="toka-info__card">

        <h1 class="toka-info__title">Suscripción mensual</h1>
        <p class="toka-info__lead">
            Acceso a los cursos y rutas de aprendizaje de la plataforma, con cobro
            automático cada mes a través de Toka.
        </p>

        <section class="toka-info__section">
            <h2>Qué incluye</h2>
            <ul>
                <li>Acceso a todo el catálogo de cursos disponibles en tu campus.</li>
                <li>Rutas de aprendizaje y seguimiento de tu progreso.</li>
                <li>Certificados de los cursos que completes.</li>
                <li>Contenido nuevo conforme se publica, sin costo adicional.</li>
            </ul>
        </section>

        <section class="toka-info__section">
            <h2>Cómo funciona el cobro</h2>
            <ul>
                <li>Autorizas el cobro una sola vez, con un código que Toka te envía por SMS.</li>
                <li>A partir de ahí el cargo se hace solo, una vez al mes, sin que tengas que
                    volver a confirmarlo.</li>
                <li>El importe y el límite máximo que autorizas aparecen en la pantalla de
                    Toka antes de que firmes.</li>
                <li>Nunca se te cobrará por encima de ese límite.</li>
            </ul>
        </section>

        <section class="toka-info__section">
            <h2>Cómo cancelar</h2>
            <p>
                Puedes cancelar cuando quieras, sin penalización, desde la sección de
                suscripciones de la plataforma o directamente desde tu aplicación de Toka.
                Al cancelar se detienen los cobros futuros y conservas el acceso hasta el
                final del periodo que ya pagaste.
            </p>
        </section>

        <section class="toka-info__section">
            <h2>Dudas o soporte</h2>
            <p>
                Escríbenos a
                <a href="mailto:soporte@myskillcamp.com">soporte@myskillcamp.com</a>
                y te ayudamos.
            </p>
        </section>

    </div>
</div>
